import { EMPTY, catchError, mergeMap, timer } from 'rxjs'
import type { WizardEpic } from './draftState.ts'

const MAX_RESTARTS = 5
const RESTART_WINDOW_MS = 60_000
const MAX_PAUSE_MS = 5_000

/**
 * An error escaping one epic would end the whole root epic, every feature's. A wizard epic that throws is
 * logged and resubscribed instead, after growing pauses, and stopped after too many failures in a minute.
 */
export const resilient =
  (epic: WizardEpic): WizardEpic =>
  (action$, state$, dependencies) => {
    let failures: number[] = []
    return epic(action$, state$, dependencies).pipe(
      catchError((error: unknown, source) => {
        const now = Date.now()
        failures = [...failures.filter((at) => now - at < RESTART_WINDOW_MS), now]
        if (failures.length > MAX_RESTARTS) {
          console.error('Order wizard epic failed too often and was stopped', error)
          return EMPTY
        }
        console.error('Order wizard epic failed and was restarted', error)
        const pause = failures.length === 1 ? 0 : Math.min(250 * 2 ** (failures.length - 2), MAX_PAUSE_MS)
        return pause === 0 ? source : timer(pause).pipe(mergeMap(() => source))
      })
    )
  }
